var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"footer-option-container"},[_c('span',{staticClass:"footer-option-label"},[_vm._v(_vm._s(_vm.$t("common.country"))+":")]),_c('div',{staticClass:"country-code"},[_vm._v(" "+_vm._s(_vm.detectedCountry)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }